export default __webpack_public_path__ + "static/media/bg_light_green_big.d4e704c9.svg";